<div class="notification-detail-page">
    <div class="grids-container">
      <!-- Change Log Grid (Top Half) -->
      <div class="grid-section change-log-section">
        <mat-card>
		<mat-card-title fxLayout="row" fxLayoutAlign="start center">
		<h3 class="readonly-label ml-1">Audit Log</h3>
	</mat-card-title>
    <mat-card-header>
			Change History for import complete on {{ importedDate }} at {{ importedTime }} Eastern 
		</mat-card-header>
      <mat-card-content class="mat-content">
        <div fxLayout fxLayoutAlign="end start" class="ml-2">
          <mat-form-field fxFlex="50%" class="mr-1">
            <input
              class="filter-box"
              matInput
              type="text"
              placeholder="Filter Change Log"
              (keyup)="applyChangeLogFilter($event)"
            />
          </mat-form-field>
        </div>
         <mat-card-header>
            <h5>Change Log</h5>
          </mat-card-header>
            <!-- Change Log Table -->
            <div class="table-container ml-1">
              <table mat-table [dataSource]="changeLogDataSource" matSort #sortChanges="matSort" class="change-log-table" *ngIf="changeLogDataSource.data.length > 0">
                <!-- Record Column -->
                <ng-container matColumnDef="record">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <strong>Record</strong>
                  </th>
                  <td mat-cell *matCellDef="let element">{{ element.record }}</td>
                </ng-container>

                <!-- Crew Member Column -->
                <ng-container matColumnDef="crewMember">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <strong>Crew Member</strong>
                  </th>
                  <td mat-cell *matCellDef="let element">{{ element.crewMember }}</td>
                </ng-container>

                <!-- Data Point Column -->
                <ng-container matColumnDef="dataPoint">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <strong>Data Point</strong>
                  </th>
                  <td mat-cell *matCellDef="let element">{{ element.dataPoint }}</td>
                </ng-container>

                <!-- Original (Before) Column -->
                <ng-container matColumnDef="original">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <strong>Original (Before)</strong>
                  </th>
                  <td mat-cell *matCellDef="let element" class="original-value">{{ element.original }}</td>
                </ng-container>

                <ng-container matColumnDef="arrow">
                  <th mat-header-cell *matHeaderCellDef class="arrow-header"></th>
                  <td mat-cell *matCellDef="let element" class="arrow-cell">
                    <mat-icon class="change-arrow">arrow_right_alt</mat-icon>
                  </td>
                </ng-container>

                <!-- Replacement (After) Column -->
                <ng-container matColumnDef="replacement">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <strong>Replacement (After)</strong>
                  </th>
                  <td mat-cell *matCellDef="let element" class="replacement-value">{{ element.replacement }}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="changeLogColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: changeLogColumns;"></tr>
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" [attr.colspan]="changeLogColumns?.length">
                    No data matching the filter.
                  </td>
                </tr>
              </table>
              <h5 class="ml-1" *ngIf="changeLogDataSource.data.length == 0">No Changes were logged in this import</h5>
            </div>
          </mat-card-content>
          <mat-card-content class="mat-content mt-xs">
      <div fxLayout fxLayoutAlign="end start" class="ml-2">
				<mat-form-field fxFlex="50%" class="mr-1">
					<input
						class="filter-box"
						matInput
						type="text"
						placeholder="Filter Error & Deletions Log"
						(keyup)="applyErrorLogFilter($event)"
					/>
				</mat-form-field>
			</div>
             <mat-card-header>
            <h5>Errors & Deletions Log</h5>
          </mat-card-header>
            <!-- Error Log Table -->
            <div class="table-container ml-1">
              <table mat-table [dataSource]="errorLogDataSource" matSort #sortErrors="matSort" class="error-log-table" *ngIf="errorLogDataSource.data.length > 0">
                <!-- Log Type Column -->
                <ng-container matColumnDef="logType">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <strong>Log Type</strong>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <span>
                      {{ element.logType }}
                    </span>
                  </td>
                </ng-container>

                <!-- Record Column -->
                <ng-container matColumnDef="record">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <strong>Record</strong>
                  </th>
                  <td mat-cell *matCellDef="let element">{{ element.record }}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="errorLogColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: errorLogColumns;"></tr>
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" [attr.colspan]="errorLogColumns?.length">
                    No data matching the filter.
                  </td>
                </tr>
              </table>
              <h5 class="ml-1" *ngIf="errorLogDataSource.data.length == 0">No Errors or Deletions were logged in this import</h5>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
</div>